import React, { ReactElement, useState } from 'react';
import { ErrorMessage, Input, Textarea } from 'idsk-react-components';
import { TextEditor } from 'slovlex-idsk-react-components';
import { SafeParameterSetter } from '../../../../../types/SafeParameterSetter';
import { ObalMaterialuNrSr } from '../../../../../model/sprievodnyDokument/obalMaterialu/ObalMaterialuNrSr';
import useFieldErrorMessages from '../../../../useFieldErrorMessages';
import FormElementWrapper from '../../../../FormElements/FormElementWrapper';
import './obalMaterialuNrSr.scss';

interface Props {
  obalMaterialu: ObalMaterialuNrSr;
  updateField: SafeParameterSetter<ObalMaterialuNrSr>;
}
export const ObalMaterialuNrSrComponent = ({ obalMaterialu, updateField }: Props): ReactElement => {
  const [initData] = useState<ObalMaterialuNrSr>(obalMaterialu);
  const { getFieldErrorMessage } = useFieldErrorMessages();
  return (
    <div className="obal-nrsr-form">
      <FormElementWrapper
        width="one-half"
        label="Číslo"
        fieldName="rezortneCislo"
        getFieldErrorMessage={getFieldErrorMessage}
        sectionClass="obal-rezortne-cislo"
      >
        <Input
          error={getFieldErrorMessage('rezortneCislo')}
          type="text"
          value={obalMaterialu.rezortneCislo}
          onChange={({ target }) => updateField('rezortneCislo', target.value)}
          maxLength={64}
        />
      </FormElementWrapper>
      <div className="centered-items__container">
        <FormElementWrapper
          sectionClass="flex-items__section"
          width="full"
          label="Nadpis riadok 1 - Číslo parlamentnej tlače"
          fieldName="cisloParlamentnejTlace"
          getFieldErrorMessage={getFieldErrorMessage}
        >
          <Input
            error={getFieldErrorMessage('cisloParlamentnejTlace')}
            type="text"
            value={obalMaterialu.cisloParlamentnejTlace}
            onChange={({ target }) => updateField('cisloParlamentnejTlace', target.value)}
            maxLength={64}
          />
        </FormElementWrapper>
        <FormElementWrapper
          sectionClass="flex-items__section"
          width="full"
          label="Nadpis riadok 2 - Vládny návrh"
          fieldName="vladnyNavrh"
          getFieldErrorMessage={getFieldErrorMessage}
        >
          <Input
            error={getFieldErrorMessage('vladnyNavrh')}
            type="text"
            value={obalMaterialu.vladnyNavrh}
            onChange={({ target }) => updateField('vladnyNavrh', target.value)}
            maxLength={64}
          />
        </FormElementWrapper>
        <FormElementWrapper
          sectionClass="flex-items__section"
          width="full"
          label="Nadpis riadok 3 - Typ materiálu"
          fieldName="typMaterialu"
          getFieldErrorMessage={getFieldErrorMessage}
        >
          <Input
            error={getFieldErrorMessage('typMaterialu')}
            type="text"
            value={obalMaterialu.typMaterialu}
            onChange={({ target }) => updateField('typMaterialu', target.value)}
            maxLength={64}
          />
        </FormElementWrapper>
      </div>
      <FormElementWrapper
        sectionClass="nazov-materialu__container"
        width="full"
        label="Nadpis riadok 4 - Názov materiálu"
        fieldName="nazovMaterialu"
        getFieldErrorMessage={getFieldErrorMessage}
      >
        <span id="hint" className="idsk-hint">Vysledný vygenerovaný dokument má limitovanú výšku.
          Ak bude text obsahovať veľa riadkov, nemusí sa do dokumentu zmestiť celý.
        </span>
        <Textarea
          error={getFieldErrorMessage && getFieldErrorMessage('nazovMaterialu')}
          id="nazovMaterialu"
          type="text"
          name="nazovMaterialu"
          value={obalMaterialu.nazovMaterialu ?? ''}
          onChange={({ target }) => updateField && updateField('nazovMaterialu', target.value)}
          rows={4}
          maxLength={330}
          showRemaining
          expandHeight
        />
      </FormElementWrapper>
      <div className="navrh-uznesenia__container">
        <FormElementWrapper
          sectionClass="flex-items__section"
          label="Návrh uznesenia"
          fieldName="navrhUznesenia"
          getFieldErrorMessage={getFieldErrorMessage}
        >
          <span id="hint" className="idsk-hint">Výsledný vygenerovaný dokument má limitovanú výšku.
            Ak bude text obsahovať veľa riadkov, nemusí sa do dokumentu zmestiť celý.
          </span>
          {getFieldErrorMessage('navrhUznesenia') && <ErrorMessage message={getFieldErrorMessage('navrhUznesenia')} />}
          <TextEditor
            initialState={initData.navrhUznesenia}
            onChange={data => updateField('navrhUznesenia', data)}
            maxLength={512}
            showRemaining
          />
        </FormElementWrapper>
      </div>
      <FormElementWrapper
        width="one-half"
        label="Predkladá"
        fieldName="predkladatel"
        getFieldErrorMessage={getFieldErrorMessage}
      >
        <span id="hint" className="idsk-hint">Výsledný vygenerovaný dokument má limitovanú výšku.
          Ak bude text obsahovať viac ako štyri riadky, nebude vo výslednom dokumente zobrazený.
        </span>
        {getFieldErrorMessage('predkladatel') && <ErrorMessage message={getFieldErrorMessage('predkladatel')} />}
        <TextEditor
          initialState={initData.predkladatel}
          onChange={data => updateField('predkladatel', data)}
          maxLength={128}
          showRemaining
        />
      </FormElementWrapper>
      <div className="centered-items__container">
        <FormElementWrapper
          sectionClass="flex-items__section"
          width="full"
          label="Miesto a dátum"
          fieldName="miestoDatum"
          getFieldErrorMessage={getFieldErrorMessage}
        >
          <Input
            error={getFieldErrorMessage('miestoDatum')}
            type="text"
            value={obalMaterialu.miestoDatum}
            onChange={({ target }) => updateField('miestoDatum', target.value)}
            maxLength={64}
          />
        </FormElementWrapper>
      </div>
    </div>
  );
};

export default ObalMaterialuNrSrComponent;
